<div
  class="gd-images-view-grid {{ gridOptions.viewAs }}"
  [class.non-interactive]="uploadQueueInProcess$ | async"
  >
  <!-- Grid wrapper -->
  <div
    #grid
    class="gd-images-view-grid__wrapper"
    [class.fixed-grid]="gridOptions.fixedGrid"
    cdkDropList
    [cdkDropListData]="collection"
    cdkDropListOrientation="mixed"
    (cdkDropListDropped)="drop($event)"
  >
    <!-- Grid item -->
    @for (item of collection; track trackGridList($index, item)) {
      <gd-image-thumbnail
        cdkDrag
        [cdkDragData]="item"
        [item]="item"
        [loading]="loading | async"
        [config]="gridOptions"
        [thumbnailProps]="gridProperties"
        [draggable]="gridOptions.thumbnailDraggable"

        [title]="getThumbnailTitle(item)"
        [isSelected]="checkIfImageIsSelected(item)"
        [hasDeletePermission]="hasDeletePermission"
        [uploadQueueActive]="processQue()"
        (click)="selectImage(item)"
        (preview)="previewImage($event)"
        (edit)="toggleEdit($event)"
        (delete)="deleteImage($event)"
        (selectImage)="selectImage($event)"
        (download)="toggleDownload($event)"
        (remove)="removeImageFromList($event)"
        (addMeta)="triggerAddImageMeta.next($event)"
        (editFile)="triggerEditFile.next($event)"
        (crop)="triggerCropImage.next($event)"
        [hasActionPermission]="hasActionPermission"
      >
      </gd-image-thumbnail>
    }
  </div>
</div>
